import moment from 'moment-timezone';

export const CheckBoxChecked = {
  yes: 'yes',
  no: 'no'
};

export const FixedTimeZone = 'America/Phoenix';

export const DateFormat = 'YYYY-MM-DD';
export const MaxDate = moment().format(DateFormat);
export const MaxFixedDate = moment().tz(FixedTimeZone).format(DateFormat);

export const DateAndTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
export const MaxDateAndTime = moment().format(DateAndTimeFormat);
export const MaxDateAndTimeFn = () => moment().format(DateAndTimeFormat);

export const CMNDexcomTemplateIdentifier = 'cmn-template-for-dexcom';

export const DEFAULT_FORMFIELD_DEXCOM = {
  patientGender: '',
  patientHeight: '',
  patientWeight: '',
  patientEmail: '',
  patientDexcomId: '',
  primaryLanguageEnglish: CheckBoxChecked.yes, // 'yes' or 'no'

  otherICD10Code: '',

  'checkbox-pump': CheckBoxChecked.no, // 'yes' or 'no'
  hhu: '',
  fingerSticks: '',
  bgLevelLow: 'Unknown',
  bgLevelHigh: 'Unknown',

  'checkbox-poi': false,
  'checkbox-3-injections-pd': false,
  'checkbox-bg-4+': false,
  'checkbox-faitr-bool': false,
  'checkbox-hhu-bool': false,
  'checkbox-had-visit': false,
  'checkbox-motivated': true,

  'checkbox-g6-receiver': CheckBoxChecked.no, // 'yes' or 'no'
  'checkbox-g6-transmitter': CheckBoxChecked.no, // 'yes' or 'no'
  'checkbox-g6-sensors': CheckBoxChecked.no, // 'yes' or 'no'
  'checkbox-g7-receiver': CheckBoxChecked.yes, // 'yes' or 'no'
  'checkbox-g7-sensors': CheckBoxChecked.yes, // 'yes' or 'no'

  orderDate: '',
};

export const PageWidth = 459; // 516;
export const PageHeight = 594; // 880;
export const HiddenElementSelector = 'd-none';
export const DOWNLOAD_CMN_PDF = process.env.REACT_APP_DOWNLOAD_CMN_PDF === 'true';

export const dateInputWrapper = 'date-input-wrapper';
export const dateDisplayWrapper = 'date-display-wrapper';

export const signatureInputWrapper = 'signature-input-wrapper';
export const signatureDisplayWrapper = 'signature-display-wrapper';

export const hiddenSpaceWrapper = 'hidden-space-wrapper';

export const A4Page = {
  orientation: 'portrait',
  unit: 'px',
  format: [PageWidth, PageHeight],
  compress: true,
  margin: {
    narrow: 16,
    normal: 32,
  },
};

export const JSPDFOutputType = {
  arraybuffer: 'arraybuffer',
  blob: 'blob',
  bloburi: 'bloburi',
  datauristring: 'datauristring',
};

export const DEFAULT_PDF_INFO = () => ({
  patientInfo: {
    dob: '',
    lastName: '',
    firstName: '',
    address: '',
    state: '',
    zip: '',
    city: '',
    phone: '',
    email: '',
  },
  prescriberInfo: {
    preName: '',
    firstName: '',
    lastName: '',
    npiNo: '',
  },
  provider: {
    signature: {
      firstName: '',
      lastNmae: '',
      prifix: ''
    },
  }
});

export const CheckBoxValue = new Map([
  [true, CheckBoxChecked.yes],
  [false, CheckBoxChecked.no],
]);

export const DocumentationTitlePageA = `Documentation:`;
export const DocumentationTitlePageB = `Documentation:`;

export const DocumentationPageA = [
  {
    key: 0,
    order: 'a.',
    label: 'CMN (Certificate of Medical Necessity)',
  },
];
export const DocumentationPageB = [
  {
    key: 0,
    order: 'a.',
    label: `Chart Notes from Patient's Most Recent Telemedicine Consultation`,
  },
];

export const ProviderTitlePageA = 'Telemedicine Consultation Completed by a Doctor Matrix Medical Group, P.A. Healthcare Provider';
export const ProviderTitlePageB = 'Telemedicine Consultation Completed by a Doctor Matrix Medical Group, P.A. Healthcare Provider';

export const ProviderDetailsPageA = [
  {
    key: 0,
    order: 'a.',
    label: `The patient was seen by a telehealth provider and may not have an established relationship with the provider beyond the singular telehealth visit.`,
  },
  {
    key: 1,
    order: 'b.',
    label: `Additional clinical documentation requirements beyond 1 visit will need to be coordinated with the patient.`,
  },
];

export const ProviderDetailsPageB = [
  {
    key: 0,
    order: 'a.',
    label: `The patient was seen by a telehealth provider and may not have an established relationship with the provider beyond the singular telehealth visit.`,
  },
  {
    key: 1,
    order: 'b.',
    label: `Additional clinical documentation requirements beyond 1 visit will need to be coordinated with the patient.`,
  },
];

export const QID_PumpCheckbox = 'QID_PumpCheckbox';
export const QID_HbA1CInput = 'QID_HbA1CInput';
export const QID_CGM = 'QID_CGM';
export const QID_Fingersticks = 'QID_Fingersticks';
export const QID_InjectInhaleInputs = 'QID_InjectInhaleInputs';
export const QID_FastingHyperglycemiaInputs = 'QID_FastingHyperglycemiaInputs';
export const QID_BGLevelHighInputs = 'QID_BGLevelHighInputs';
export const QID_BGLevelLowInputs = 'QID_BGLevelLowInputs';
export const QID_PatientOnInsulinCheckbox = 'QID_PatientOnInsulinCheckbox';
export const QID_3InjectionsPDCheckbox = 'QID_3InjectionsPDCheckbox';
export const QID_PatientSelfChecksBGCheckbox = 'QID_PatientSelfChecksBGCheckbox';
export const QID_FrequentAdjustmentsInTreatmentCheckbox = 'QID_FrequentAdjustmentsInTreatmentCheckbox';
export const QID_HypoglycemiaUnawarenessSymptomsCheckbox = 'QID_HypoglycemiaUnawarenessSymptomsCheckbox';

export const ICD10CODES = [
  {
    key: 'code-1',
    code: 'E10.65',
  },
  {
    key: 'code-2',
    code: 'E10.9',
  },
  {
    key: 'code-3',
    code: 'E11.9',
  },
  {
    key: 'code-4',
    code: 'O24.41(for G7 only)',
  },
];

/**
 * @description Dexcom test data will be used for testing
 */
export const STOREFRONT_APPLICATION_SETTINGS = [
  {
    SettingKey: "MOBILE",
    SettingName: "Mobile",
    SettingValue: "False",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "CARTLIFE",
    SettingName: "CartLife",
    SettingValue: "8760",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "NONSHIPPEROPTION",
    SettingName: "NonShipperOption",
    SettingValue: "35",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "BOTTLELABELTYPE",
    SettingName: "BottleLabelType",
    SettingValue: "1",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "FORGOTPASSWORDRESET",
    SettingName: "ForgotPasswordReset",
    SettingValue: "/reset-password/?GUID=",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "AUTHKEY",
    SettingName: "authKey",
    SettingValue: "aws123uat",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "SYSTEMACTIVE",
    SettingName: "SystemActive",
    SettingValue: "true",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: "PHONEORDER",
    SettingName: "PhoneOrder",
    SettingValue: "/phoneorder/?kwikadmin=1",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "PHONEORDERRETURNURL",
    SettingName: "PhoneOrderReturnURL",
    SettingValue: "/login",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "FORCEPASSWORDCHANGEAFTER",
    SettingName: "ForcePasswordChangeAfter",
    SettingValue: "99999",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "AVATAXLICENSE",
    SettingName: "avataxLicense",
    SettingValue: "521F5E3D48EF0CE5",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "CONSULTTIMEEVISIT",
    SettingName: "ConsultTimeEvisit",
    SettingValue: "2min",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "CONSULTTIMEDEFAULT",
    SettingName: "ConsultTimeDefault",
    SettingValue: "2min",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "CONSULTTIMELPQ",
    SettingName: "ConsultTimeLPQ",
    SettingValue: "2min",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "ALLVIDEO",
    SettingName: "AllVideo",
    SettingValue: "True",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "kLAVIYO_PUBLICKEY",
    SettingName: "klaviyo_publicKey",
    SettingValue: "xxxxxxxx",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "kLAVIYO_PRIVATEKEY",
    SettingName: "klaviyo_privateKey",
    SettingValue: "xxxxxxxxxxxxx",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "MAILCHIMPLISTID",
    SettingName: "MailchimpListId",
    SettingValue: "xxxxxxx",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "DEFAULTTAXRATE",
    SettingName: "DefaultTaxRate",
    SettingValue: "0.1",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "TAXURL",
    SettingName: "TAXURL",
    SettingValue: "https://uatrbpriv.upscripthealth.org/avataxagtr",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "PAYMENTOPTIONP2D",
    SettingName: "PaymentOption_P2D",
    SettingValue: "False",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "PASSWORDEXPIRETIME",
    SettingName: "PasswordExpireTime",
    SettingValue: "6",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: "PAYMENTOPTION_PAID",
    SettingName: "PaymentOption_PAID",
    SettingValue: "False",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "PAYMENTOPTIONCC",
    SettingName: "PaymentOption_CC",
    SettingValue: "True",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "AVATAXACCOUNT",
    SettingName: "avataxAccount",
    SettingValue: "2001445293",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "PAYMENTOPTIONWT",
    SettingName: "PaymentOption_WT",
    SettingValue: "False",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "GETTAX",
    SettingName: "GetTax",
    SettingValue: "False",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "PAYMENTOPTIONMO",
    SettingName: "PaymentOption_MO",
    SettingValue: "False",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "AUTOREFILLNOTIFYINTERVAL",
    SettingName: "AutoRefillNotifyInterval",
    SettingValue: "2",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "AUTOREFILLPAGEURL",
    SettingName: "AutoRefillPageURL",
    SettingValue: "my-account/auto-refill",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "AUTOFILLAUTHORIZATIONPAGEURL",
    SettingName: "AutoFillAuthorizationPageURL",
    SettingValue: "my-account/autorefillauthorization",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "COMPANYCSRPHONEURL",
    SettingName: "CompanyCSRPhoneUrl",
    SettingValue: "/phoneOrderNewReg/",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "USEENCRYPTION",
    SettingName: "UseEncryption",
    SettingValue: "False",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "ENCRYPTSALT",
    SettingName: "EncryptSalt",
    SettingValue: "154729",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: "AVATAXCLIENT",
    SettingName: "avataxClient",
    SettingValue: "BELLA BRANDS LLC",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: "PHARMCOUPON",
    SettingName: "PharmCoupon",
    SettingValue: "162842",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "PharmacyChoice",
    SettingValue: "Hybrid",
    Description: "Internal, External, or Hybrid",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "PharmacyChoice",
    SettingValue: "Hybrid",
    Description: "Internal, External, or Hybrid",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "PharmacyChoice",
    SettingValue: "Hybrid",
    Description: "Internal, External, or Hybrid",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "PharmacyChoice",
    SettingValue: "Hybrid",
    Description: "Internal, External, or Hybrid",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "PharmacyChoice",
    SettingValue: "Hybrid",
    Description: "Internal, External, or Hybrid",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "PharmacyChoice",
    SettingValue: "Hybrid",
    Description: "Internal, External, or Hybrid",
    IsDefault: false,
  },
  {
    SettingKey: "IDKPID",
    SettingName: "IDK-PID",
    SettingValue: "1268",
    Description: null,
    IsDefault: true,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "PharmacyChoice",
    SettingValue: "Hybrid",
    Description: "Internal, External, or Hybrid",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "PharmacyChoice",
    SettingValue: "Hybrid",
    Description: "Internal, External, or Hybrid",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ConsultBuilder",
    SettingValue: "True",
    Description: "ConsultBuilder",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SSLURL",
    SettingValue: "https://uatgetdexcomrx.upscripthealth.org",
    Description: "SSL Description",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "LocalPickup_CarrierId",
    SettingValue: "35",
    Description: "LocalPickup_CarrierId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPassword",
    SettingValue:
      "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",
    Description: "SmtpPassword",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpPort",
    SettingValue: "25",
    Description: "SmtpPort",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "UseConsultFollowUp",
    SettingValue: "True",
    Description: "UseConsultFollowUp",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmsListId",
    SettingValue: "WyHXG7",
    Description: "SmsListId",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CC_ChargeAtCheckout",
    SettingValue: "True",
    Description: "CC_ChargeAtCheckout",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailAddress",
    SettingValue: "service@GetDexcomRx.com",
    Description: "EmailAddress",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpUser",
    SettingValue: "apikey",
    Description: "SmtpUser",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QuestionnaireTagLine",
    SettingValue: "Questionnaire for G7 CGM",
    Description: "QuestionnaireTagLine",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "HomeURL",
    SettingValue: "GetDexcomRx.com",
    Description: "Home URL",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SmtpRelay",
    SettingValue: "smtp.sendgrid.net",
    Description: "SmtpRelay",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "iterable_token",
    SettingValue: "8f0c6cc2f4764e549861572350b2a95e",
    Description: "iterable_token",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "EmailDomain",
    SettingValue: "GetDexcomRx.com",
    Description: "EmailDomain",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CompanyName",
    SettingValue: "GetDexcomRx.com",
    Description: "CompanyName",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "CalendlyRoundRobin",
    SettingValue: "True",
    Description: "CalendlyRoundRobin",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "PharmacyChoice",
    SettingValue: "Hybrid",
    Description: "Internal, External, or Hybrid",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "ProvidersAndCreatePDF",
    SettingValue: "Dexcom",
    Description: "Enter value Dexcom or False is not needed",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "PID_ProvidersAndCreatePDF",
    SettingValue: "1468",
    Description:
      "We can use comma separated values for multiple product ids. Eg. 1468,1469",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_PumpCheckbox",
    SettingValue: "117443",
    Description: "value. Comma separated ids can be used.",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_HbA1CInput",
    SettingValue: "117452",
    Description: "A1C",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_CGM",
    SettingValue: "117446",
    Description: "Currently on CGM",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_Fingersticks",
    SettingValue: "117446,1174488",
    Description: "Fingersticks: value.",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_FastingHyperglycemiaInputs",
    SettingValue: "117454",
    Description: "Fasting Hyperglycemia: value.",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_BGLevelHighInputs",
    SettingValue: "117456",
    Description: "Fluctuating of BG Level: High: value.",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_BGLevelLowInputs",
    SettingValue: "117455",
    Description: "Fluctuating of BG Level: Low: value.",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_PatientOnInsulinCheckbox",
    SettingValue: "117443",
    Description: "Patient is on insulin therapy checkbox.",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_3InjectionsPDCheckbox",
    SettingValue: "117443,117444",
    Description: "Patient administers 3+ injections per day ... checkbox.",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_PatientSelfChecksBGCheckbox",
    SettingValue: "117446,117448",
    Description: "Patient self checks BG 4+ times ... checkbox.",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_FrequentAdjustmentsInTreatment",
    SettingValue: "117449",
    Description: "Patient's insulin treatment requires ... checkbox.",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_HypoglyemiaUnawarenessSympt",
    SettingValue: "117442",
    Description: "History of hypoglycemia unawareness, severe ... checkbox.",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "SkipSendPDFToPartner",
    SettingValue: "True",
    Description: "will skip sending the PDF to partner.",
    IsDefault: false,
  },
  {
    SettingKey: null,
    SettingName: "QID_InjectInhaleInputs",
    SettingValue: "117443,117444",
    Description: "Injections",
    IsDefault: false,
  },
];

export const PRODUCT_INFORMATION = {
  OrderId: 2023103158335974,
  OrderDate: "09/05/2024",
  StoreFrontURL: "GetDexcomRx.com",
  Product: [
    {
      ProductId: 1468,
      ProductTitle: "1 Dexcom G7 CGM System - 1",
      ProductName: "Dexcom G7 CGM System",
      ProductType: "Kit",
      Qty: 1,
      OrderType: "New Order",
      Status: "Pending Fulfillment",
      RequiresPrescription: 1,
      IsAlternateRx: false,
      PrescriberProductDisplayName: "Dexcom G7 CGM System (DME Distributor)",
      Pharmacy: "Pharmacy - N/A",
      AutRefill: false,
      Shipping: "NA",
      IsLabProduct: false,
      LabStatus: null,
    },
  ],
  StoreFrontData: {
    StorefrontName: "GetDexcomRx",
    CompanyId: 4823162,
    StorefrontId: 122,
    WorkingName: "GetDexcomRx.com",
    EmailDomain: "GetDexcomRx.com",
    StorefrontApplicationSettings: STOREFRONT_APPLICATION_SETTINGS,
  },
  StoreFrontId: 0,
};

export const CMN_PDF_DATA = {
  scriptStatus: null,
  sentTo: {
    faxno: 0,
    sentDate: "2024-09-10T11:59:35.3081312+00:00",
  },
  orderInfo: {
    orderId: 2024090542510618,
    soapNote: null,
    orderNote: null,
    orderstatus: null,
    questions: [],
  },
  patientInfo: {
    id: 4559365,
    PreName: null,
    firstName: "R917",
    lastName: "Sep5",
    prifix: null,
    dob: "08/08/1998 00:00:00",
    address: "5665 N Scottsdale rd",
    state: "Arizona",
    zip: 85254,
    city: "Scottsdale",
    phone: "4805223232",
    insuranceCompany: null,
    insuranceNo: 0,
    email: "R917@Sep5.com",
  },
  prescriberInfo: {
    id: 4183530,
    preName: "NP.",
    firstName: "Brian",
    lastName: "Greenbush",
    address: "123 Main Street",
    state: "AZ",
    zip: 85254,
    city: "Scottsdale",
    phone: null,
    fax: null,
    npiNo: "1316300585",
  },
  medicalNecessity: {
    medicalQestionnaire: [],
  },
  priorAuthorizationReview: {},
  provider: {
    attestationDate: "2024-09-10T11:59:35.308132+00:00",
    signature: {
      prifix: "NP.",
      firstName: "Brian",
      lastNmae: "Greenbush",
    },
  },
};

export const CONSULT_WITH_QUESTIONS = {
  OrderId: 2023103158335974,
  ProductConsultDetails: [
    {
      ProductId: 1468,
      ProductTitle: "1 Dexcom G7 CGM System - 1",
      QuestionAnswers: [
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117430,
          Language: "ENG",
          QuestionText: "Date of Birth - DoB",
          AnswerText: "08/08/1998",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117431,
          Language: "ENG",
          QuestionText: "Height and Weight",
          AnswerText: "7' 4,495",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117432,
          Language: "ENG",
          QuestionText: "Gender",
          AnswerText: "M",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117433,
          Language: "ENG",
          QuestionText: "Shipping State",
          AnswerText: "AZ",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117434,
          Language: "ENG",
          QuestionText: "Phone Number",
          AnswerText: "4805223232",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117439,
          Language: "ENG",
          QuestionText:
            "Welcome!   We are going to ask you a series of questions about your medical history.   A Doctor or Nurse Practitioner will review your responses to determine if the Dexcom CGM System is right for you.    Have you been diagnosed with any of the following?",
          AnswerText: "Type 1 Diabetes",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117440,
          Language: "ENG",
          QuestionText:
            "Please select any of the following that currently apply to you:",
          AnswerText: "None or unknown",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117437,
          Language: "ENG",
          QuestionText:
            "Select your primary insurance coverage from the list below to ensure if approved, your prescription is sent to the right location.",
          AnswerText:
            "Commercial insurance (generally through an employer or purchased on the private market)     Examples include United Healthcare, BlueCross BlueShield, etc.",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117428,
          Language: "ENG",
          QuestionText:
            "Please enter the name of your insurance plan below.   (e.g., UnitedHealthcare, Humana, Aetna, Blue Cross Blue Shield of Arizona, etc.)",
          AnswerText: "Humana",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117458,
          Language: "ENG",
          QuestionText:
            "What medical supply distributor referred you to telehealth?",
          AnswerText: "Adapt Health (Solara)",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117441,
          Language: "ENG",
          QuestionText:
            "Do any of the following apply to you?   Please select all that may apply:",
          AnswerText:
            "When my blood sugar is elevated to 200 mg/dl, I often do not experience symptoms ",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117441,
          Language: "ENG",
          QuestionText:
            "Do any of the following apply to you?   Please select all that may apply:",
          AnswerText: "I have had a fasting blood sugar over 150",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117441,
          Language: "ENG",
          QuestionText:
            "Do any of the following apply to you?   Please select all that may apply:",
          AnswerText:
            "Even when I inject insulin, my blood sugar levels can fluctuate high or low",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117441,
          Language: "ENG",
          QuestionText:
            "Do any of the following apply to you?   Please select all that may apply:",
          AnswerText:
            "I have had high blood sugar that required medical assistance (including calling 911 or going to the ER)",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117442,
          Language: "ENG",
          QuestionText: "Select any of the following that you have experienced:",
          AnswerText:
            "When my blood sugar drops under 80 mg/dl, I often do not experience symptoms ",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117442,
          Language: "ENG",
          QuestionText: "Select any of the following that you have experienced:",
          AnswerText: "I have had a low blood sugar less than 50",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117442,
          Language: "ENG",
          QuestionText: "Select any of the following that you have experienced:",
          AnswerText: "I frequently have low blood sugars during sleep",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117442,
          Language: "ENG",
          QuestionText: "Select any of the following that you have experienced:",
          AnswerText:
            "I have recurring episodes of severe hypoglycemia (low blood sugar)",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:52",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117442,
          Language: "ENG",
          QuestionText: "Select any of the following that you have experienced:",
          AnswerText:
            "I have had low blood sugar that required medical assistance (including calling 911 or going to the ER)",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117443,
          Language: "ENG",
          QuestionText:
            "From the list below, please select all types of therapy you are using to manage your diabetes.",
          AnswerText: "Insulin using a pump",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117443,
          Language: "ENG",
          QuestionText:
            "From the list below, please select all types of therapy you are using to manage your diabetes.",
          AnswerText: "Inhaled Insulin (e.g. Afrezza)",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117444,
          Language: "ENG",
          QuestionText:
            "Considering all insulin types, how many times per day are you currently taking insulin?",
          AnswerText: "More than 6 times per day",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117445,
          Language: "ENG",
          QuestionText: "How long have you been using insulin?",
          AnswerText: "More than 3 years",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117446,
          Language: "ENG",
          QuestionText:
            "Please select the response that best describes your use of CGM Systems:",
          AnswerText: "I am currently using a CGM",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117450,
          Language: "ENG",
          QuestionText:
            "Do you experience any of the following often?   Select all that may apply.",
          AnswerText: "Hyperglycemia (high blood sugar levels)",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117452,
          Language: "ENG",
          QuestionText: "What is your most recent A1C level?",
          AnswerText: "8.9",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117453,
          Language: "ENG",
          QuestionText:
            "When was your last A1C taken?   Please enter the MM/DD/YY below.",
          AnswerText: "02.02.2024",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117454,
          Language: "ENG",
          QuestionText:
            "What is your typical fasting blood glucose value?\n (i.e. immediately upon waking up and before you have anything to eat or drink.)",
          AnswerText: "6",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117455,
          Language: "ENG",
          QuestionText:
            "What is typically your lowest blood glucose value (mg/dL) and how frequently does your blood glucose reach that lowest value?",
          AnswerText: "3mg/dl",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117456,
          Language: "ENG",
          QuestionText:
            "What is typically your highest blood glucose value (mg/dL) and how frequently does your blood glucose reach that highest value?",
          AnswerText: "10",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 117457,
          Language: "ENG",
          QuestionText:
            "Have you been educated on how to manage your diabetes from a healthcare provider?",
          AnswerText: "Yes",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 6025,
          Language: "ENG",
          QuestionText:
            "Please list all medications you are currently taking for any condition, including both prescription and over-the-counter medications.",
          AnswerText: "DRISDOL",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 6026,
          Language: "ENG",
          QuestionText:
            "Please list any serious illnesses you have or have had in the past (e.g. cancer, liver disease or heart disease, etc.)",
          AnswerText: "svd",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
        {
          Flagged: false,
          ConsultId: 3691357,
          QuestionId: 6027,
          Language: "ENG",
          QuestionText:
            "Please list any allergies you currently have or had in the past.",
          AnswerText: "sv",
          AnswerType: null,
          EntryDate: "2024-09-05T09:22:53",
          LogicalDelete: 0,
          ExpectedAnswer: null,
        },
      ],
    },
  ],
};
